import request from '@/utils/request'

export const kamplariGetir = (q) => {
    const params = {};
    if (q !== "")
        params["q"] = q;

    return request({
        url: 'Kamp/KamplariGetir',
        params
    })
};

export const idyeGoreKampiGetir = (id) => {
    return request({
        url: 'Kamp/GetKampById',
        params: {
            id
        }
    })
};

export const kampIsmiTeklifEt = (kampIsim, belgePath) => {
    return request({
        url: 'Kamp/KampIsmiTeklif',
        method: 'post',
        params: {
            kampIsim,
            belgePath
        }
    })
}

export const YeniKampYeriEkle = (kampIsim, ulke) => {
    return request({
        url: 'Kamp/YeniKampYeriEkle',
        method: 'post',
        params: {
            kampIsim,
            ulke
        }
    })
}
